/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react'
import { connect } from 'react-redux'
import { Dispatcher, IMenu } from 'AppTypes'
import MenuMedia from './MenuMedia'
import * as menuActions from '../state_management/actions'

const mapDispatchToProps = (dispatch: Dispatcher) => ({
  fetchMenuById: (id: string) => dispatch(menuActions.fetchMenuById(id))
})

type MenuDetailsProps = ReturnType<typeof mapDispatchToProps> & { menuItem: IMenu }

const MenuDetails: React.FC<MenuDetailsProps> = ({
  menuItem,
  fetchMenuById
}) => (
  <div className="menu-cat">
    <h3 onClick={() => fetchMenuById(menuItem.id)}>{menuItem.menuName}</h3>
    <div className="d-flex flex-wrap menu-item">
      {
        menuItem.video != null
        && menuItem.video !== ''
        && <video controls><source src={menuItem.video} /><track kind="captions" /></video>
      }
      {menuItem.images.map(img => <MenuMedia media={img} />)}
    </div>
  </div>
)

export default connect(
  null,
  mapDispatchToProps
)(MenuDetails)
